import * as React from "react"
const SvgComponent = (props) => {
  const getRotation = () => {
    if (props.direction === 'right') return 'rotate(0deg)'
    if (props.direction === 'left') return 'rotate(180deg)'
    if (props.direction === 'top') return 'rotate(270deg)'
    if (props.direction === 'bottom') return 'rotate(90deg)'
    return 'rotate(0deg)'
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={7}
      height={12}
      fill="none"
      {...props}
      style={{
        ...props.style,
        transform: getRotation(),
        transformOrigin: 'center',
      }}
    >
      <path
        fill={props.fill ? props.fill : '#666666'}
        fillRule="evenodd"
        d="M.287 11.705a1 1 0 0 1 .012-1.414l4.365-4.289L.3 1.713A1 1 0 1 1 1.704.287l4.942 4.86a1.2 1.2 0 0 1 0 1.712L1.7 11.717a1 1 0 0 1-1.414-.012Z"
        clipRule="evenodd"
      />
    </svg>
  )
}
export default SvgComponent
